import Vue from 'vue'
import VueRouter from 'vue-router'

import Main from '@/layout/index.vue'
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import NotFound from '@/views/NotFound.vue'
import BudgetSheet from '@/views/budgetSheet/index.vue'
import UserManagement from '@/views/userManagement/index.vue'
import UserManagementDetails from '@/views/userManagement/details/index.vue'

// import UserSetting from '@/views/mobile/userSetting.vue'
import Orther from '@/views/other/index.vue'
Vue.use(VueRouter)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main,
    redirect: '/login',
    children: [
      { path: 'home', component: Home },
      { path: 'budgetSheet', component: BudgetSheet },
      { path: 'userManagement', component: UserManagement },
      { path: 'userManagementDetails', component: UserManagementDetails },
      { path: 'orther', component: Orther }
      // { path: 'userSetting', component: UserSetting }
    ]
  },
  {
    path: '/about',
    name: 'about'
    // component: () => import('@/layout/components/Sidebar/index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  routes
})

// 导航守卫
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('access_token')

  if (token) {
    next()
  } else {
    if (to.path === '/login') {
      // 如果当前路由是登录页，直接放行
      next()
    } else {
      // 如果需要验证权限但不存在token，重定向到登录页
      next('/login')
    }
  }

  // if (token) {
  //   if (to.meta.requiresAuth) {
  //     // 如果需要验证权限且存在token，放行路由
  //     next()
  //   } else {
  //     // 不需要验证权限的路由直接放行
  //     next()
  //   }
  // } else {
  //   if (to.path === '/login') {
  //     // 如果当前路由是登录页，直接放行
  //     next()
  //   } else {
  //     // 如果需要验证权限但不存在token，重定向到登录页
  //     next('/login')
  //   }
  // }
})
export default router
